import axios from 'axios';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import { fetchHandler, postHandler } from '../../utils/apiUtils';
import { isEmpty } from 'lodash';
import { transformToClientAccessList } from '../../utils/screenPermission';
import { getFilenameFromHttpResponseNew } from './ReportApi';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchSamples = async ({
  locationIdentifier,
  locationFormat,
  sampleNumber,
  maxxID,
  clientID,
  analysisType,
  sampleStatus,
  maxxAlertStatus,
  clientReviewStatus,
  clientIDs,
  reportAddressIDs,
  scenarioIDs,
  attentionName,
  area,
  samplePoint,
  jobNumber,
  matrix,
  projectNumber,
  poNumber,
  receivedDateFrom,
  receivedDateTo,
  sampleDateFrom,
  sampleDateTo,
  clientAccessList,
  sourceSystemIDs,
  divisionIDs,
  page,
  pageSize,
  sortBy,
  functionality,
}) => {
  const queryParams = [];
  // console.log(clientIDs, reportAddressIDs, scenarioIDs);
  const clientAccessFilter = transformToClientAccessList(clientIDs, reportAddressIDs, scenarioIDs);
  if (locationIdentifier) {
    queryParams.push(`locationFormat=${encodeURIComponent(locationIdentifier.id)}`);
    queryParams.push(`locationIdentifierFlag=${locationIdentifier.flags}`);
  }
  if (locationFormat && locationFormat.masked && locationFormat.masked.trim() !== '') {
    queryParams.push(`locationIdentifier=${encodeURIComponent(locationFormat.masked.trim())}`);
  }
  if (sampleNumber && sampleNumber.trim() !== '') {
    queryParams.push(`sampleNo=${encodeURIComponent(sampleNumber.trim())}`);
    queryParams.push('sampleNoOP=Contains');
  }
  if (maxxID && maxxID.trim() !== '') {
    queryParams.push(`maxId=${encodeURIComponent(maxxID.trim())}`);
    // queryParams.push('maxIdOP=Contains');
  }
  if (clientID && clientID.trim() !== '') {
    queryParams.push(`clientId=${encodeURIComponent(clientID.trim())}`);
    // queryParams.push('clientIdOP=Contains');
  }
  if (analysisType) {
    queryParams.push(`analysisTypeNames=${encodeURIComponent(analysisType.text)}`);
  }
  if (sampleStatus) {
    queryParams.push(`sampleStatusName=${encodeURIComponent(sampleStatus.text)}`);
  }
  if (maxxAlertStatus) {
    queryParams.push(`maxAlertStatusNames=${encodeURIComponent(maxxAlertStatus.text)}`);
  }
  if (clientReviewStatus) {
    queryParams.push(`clientReviewStatusNames=${encodeURIComponent(clientReviewStatus.text)}`);
  }

  if (attentionName && attentionName.trim() !== '') {
    queryParams.push(`attentionNames=${encodeURIComponent(attentionName.trim())}`);
    queryParams.push('attentionNameOP=Contains');
  }
  if (area && area.trim() !== '') {
    queryParams.push(`field=${encodeURIComponent(area.trim())}`);
    queryParams.push('fieldOP=Contains');
  }
  if (samplePoint && samplePoint.trim() !== '') {
    queryParams.push(`samplePoint=${encodeURIComponent(samplePoint.trim())}`);
    queryParams.push('samplePointOP=Contains');
  }
  if (jobNumber && jobNumber.trim() !== '') {
    queryParams.push(`jobNo=${encodeURIComponent(jobNumber.trim())}`);
    queryParams.push('jobNoOP=Contains');
  }
  if (Array.isArray(matrix) && matrix.length > 0) {
    // const ids = matrix.map((m) => m.id).join(',');
    const names = matrix.map((m) => m.text).join(',');
    queryParams.push(`matrixNames=${names}`);
  }
  if (projectNumber && projectNumber.trim() !== '') {
    queryParams.push(`projectNo=${encodeURIComponent(projectNumber.trim())}`);
    queryParams.push('projectNoOP=Contains');
  }
  if (poNumber && poNumber.trim() !== '') {
    queryParams.push(`poNo=${encodeURIComponent(poNumber.trim())}`);
    queryParams.push('poNoOP=Contains');
  }

  if (receivedDateFrom) {
    queryParams.push(
      `receivedDateFrom=${encodeURIComponent(receivedDateFrom)}`
    );
  }

  if (receivedDateTo) {
    queryParams.push(
      `receivedDateTo=${encodeURIComponent(receivedDateTo)}`
    );
  }
  if (sampleDateFrom) {
    queryParams.push(
      `sampleDateCreatedFrom=${encodeURIComponent(sampleDateFrom)}`
    );
  }

  if (sampleDateTo) {
    queryParams.push(`sampleDateCreatedTo=${encodeURIComponent(sampleDateTo)}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }
  if (functionality) {
    queryParams.push(`functionality=${encodeURIComponent(functionality)}`);
  }
  if (clientAccessFilter) {
    if (!isEmpty(clientAccessFilter?.ClientAccessList)) {
      queryParams.push(`clientAccessFilter=${encodeURIComponent(JSON.stringify(clientAccessFilter))}`);
    }
  }
  if (clientAccessList) {
    queryParams.push(`clientAccessFilter=${encodeURIComponent(JSON.stringify({ ClientAccessList: clientAccessList }))}`);
  }
  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }
  // console.log('Query params: ', queryParams);
  try {
    const response = await axiosInstance.get(
      `/sample/all/petrohub?${queryParams.join('&')}`
    );

    // return response.data.Data.length > 0 ? response.data : { Data: dummySampleResult.data.samples };
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getSampleBySampleId = async ({
  sampleId,
  assignedDivisions }) => {
  const queryParams = [];
  if (Array.isArray(assignedDivisions) && assignedDivisions.length > 0) {
    queryParams.push(`divisionIds=${assignedDivisions.join(',')}`);
  }
  try {
    const response = await axiosInstance.get(`/sample/samples/id/${sampleId}/Petrohub?${queryParams.join('&')}`);

    // return response.data ? response.data : dummySampleDetailsData;
    return response.data;
  } catch (e) {
    throw new Error('Error getSampleBySampleId');
  }
};

const getManyResultsBySampleId = async (sampleId) => {
  try {
    const response = await axiosInstance.get(
      `/sample/results/sampleId/${sampleId}/withSpec/Petrohub`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data; // List of ResultDTO
  } catch (e) {
    throw new Error('Error getManyResultsBySampleId');
  }
};

const searchSampleAlerts = async ({
  locationIDs,
  clientIDs,
  sourceSystemIDs,
  projects,
  page,
  pageSize,
  sortBy,
}) => {
  const queryParams = [];

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/sample/SampleAlerts?${queryParams.join('&')}`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const createCarRequest = async ({ sampleId }) => {
  try {
    const response = await axiosInstance.post('/sample/CreateCarRequest', {
      SampleID: sampleId,
    });

    return response.data;
  } catch (e) {
    throw new Error('Error createCarRequest');
  }
};

const getTestReportingGroups = async ({ sampleId }) => {
  const queryParams = [];

  if (sampleId) {
    queryParams.push(`sampleIdText=${sampleId}`);
  }
  try {
    const response = await axiosInstance.post(
      `Sample/GetTestReportingGroups?${queryParams.join('&')}`
    );
    // console.log(response.data);
    return response.data;
  } catch (e) {
    throw new Error('Error GetTestReportingGroups');
  }
};

const getRecentSamples = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `sampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `/sample/RecentSamples?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getRecentSamplesVF = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    page,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `SampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `Stats/sample/count/all?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getSampleResultHistory = async ({ assetPartId, locationId }, abortController) => {
  const queryParams = [];

  if (assetPartId) {
    queryParams.push(`assetPartId=${encodeURIComponent(assetPartId)}`);
  }

  if (locationId) {
    queryParams.push(`locationId=${locationId}`);
  }

  try {
    const response = await axiosInstance.post(
      `/Sample/GetSampleResultHistory?${queryParams.join('&')}`, {}, {
        signal: abortController?.signal
      }
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Cancel request getSampleResultHistory');
      return {};
    }
    throw e;
  }
};

const getJobTurnaroundTime = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/JobTurnAroundTime', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRushJobTurnaroundTime = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/RushJobTurnAroundTime', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSampleSubmittedOP = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/SamplesSubmittedComparison', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);
const getSampleReportedOP = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/SamplesReportedComparison', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSamplesByAnalysisTypeOP = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/SamplesByAnalysisType', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSampleStatusOP = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/SamplesByStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const clientReviewStatus = async ({ sampleId, action }, abortController) => {
  postHandler(axiosInstance, `/Sample/Update/${sampleId}/ClientReviewStatus?clientReviewStatus=${action}`, abortController);
};
const getAnalysisType = async () => {
  // fetchHandler(axiosInstance, '/Sample/AnalysisType/All', { text }, abortController);
  try {
    const response = await axiosInstance.get(
      '/Sample/AnalysisType/All',
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Cancel request getAnalysisType');
      return {};
    }
    throw e;
  }
};

const getClientReportTemplates = async (clients, abortController) => postHandler(
  axiosInstance,
  '/Sample/ClientReports/Petrohub',
  clients,
  abortController,
);

const downloadFullCOAPetrohub = async (reportType, jobIdTexts = []) => {
  try {
    if (!reportType || !jobIdTexts || !Array.isArray(jobIdTexts) || jobIdTexts.length === 0) {
      throw new Error('Invalid parameters for downloadFullCOAPetrohub');
    }
    const response = await axiosInstance.post(
      `/Report/GetFullJobReports/JobIDTexts/ReportType${reportType}`,
      jobIdTexts,
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return response;
  } catch (e) {
    console.log('Error in downloadFullCOAPetrohub: ', e);
    throw e;
  }
};
const downloadReportByReportID = async ({ jobReportId }) => {
  try {
    const response = await axiosInstance.post(
      `/report/Download/ReportID${jobReportId}/Petrohub`,
      null,
      {
        responseType: 'blob',
      },
    );

    const contentType = response?.headers?.['content-type'] || 'application/octet-stream';
    const fileName = getFilenameFromHttpResponseNew(response);
    const blobData = response?.data instanceof Blob
      ? response.data
      : new Blob([response.data], { type: contentType });

    return {
      blobData,
      fileName,
      contentType,
    };
  } catch (e) {
    throw new Error('Error downloadReportByReportID');
  }
};

const PetrohubSampleApi = {
  downloadReportByReportID,
  clientReviewStatus,
  getAnalysisType,
  getClientReportTemplates,
  downloadFullCOAPetrohub,
  searchSamples,
  getSampleBySampleId,
  getManyResultsBySampleId,
  searchSampleAlerts,
  createCarRequest,
  getRecentSamples,
  getRecentSamplesVF,
  getTestReportingGroups,
  getSampleResultHistory,
  getJobTurnaroundTime,
  getRushJobTurnaroundTime,
  getSampleSubmittedOP,
  getSampleReportedOP,
  getSamplesByAnalysisTypeOP,
  getSampleStatusOP,
};

export default PetrohubSampleApi;
